import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["useResponsiveSpacing", "smMd"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import React from "react";
import classNames from "classnames";
import { Grid as MuiGrid, useTheme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import useWindowSize from "hooks/useWindowSize";

/* This is a wrapper around the v4 Material UI Grid Component.
 * The wrapper extends the functionality of the Base MUI Component by allowing you to use
 * custom breakpoints w/ the Grid component. By default MUI only allows you to define Grid sizes
 * for the default breakpoints (xs, sm, md, lg, xl).
 */
import { jsx as _jsx } from "react/jsx-runtime";
// From MUI Grid Layout implementation, calculates the value use in flexBasis and maxWidth for Grid layout
// https://github.com/mui/material-ui/blob/v4.12.4/packages/material-ui/src/Grid/Grid.js#L48
var createCustomGridStyle = function createCustomGridStyle(size) {
  if (size === "auto") {
    return {
      flexBasis: "auto",
      flexGrow: 0,
      maxWidth: "none"
    };
  }
  var gridSize = "".concat(Math.round(size / 12 * 10e7) / 10e5, "%");
  return {
    flexBasis: gridSize,
    flexGrow: 0,
    maxWidth: gridSize
  };
};
var getResponsiveGridSpacing = function getResponsiveGridSpacing(windowWidth, theme) {
  if (windowWidth >= _valuesInstanceProperty(theme.breakpoints).lg) {
    return 4; // 32px
  } else if (windowWidth >= _valuesInstanceProperty(theme.breakpoints).smMd) {
    return 3; // 24px
  }
  return 2; // default: 16px
};
var Grid = function Grid(_ref) {
  var _windowSize$innerWidt;
  var _ref$useResponsiveSpa = _ref.useResponsiveSpacing,
    useResponsiveSpacing = _ref$useResponsiveSpa === void 0 ? false : _ref$useResponsiveSpa,
    _ref$smMd = _ref.smMd,
    smMd = _ref$smMd === void 0 ? false : _ref$smMd,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var windowSize = useWindowSize();
  var windowWidth = (_windowSize$innerWidt = windowSize.innerWidth) !== null && _windowSize$innerWidt !== void 0 ? _windowSize$innerWidt : 0;
  var isOnlySmMdSize = windowWidth >= _valuesInstanceProperty(theme.breakpoints).smMd && windowWidth < _valuesInstanceProperty(theme.breakpoints).md;
  var useSmMdClass = isOnlySmMdSize && smMd !== false;
  var gridStyles = {};
  if (smMd !== false) {
    gridStyles.smMdGrid = createCustomGridStyle(smMd);
  }
  var gridClasses = makeStyles(function (theme) {
    return gridStyles;
  })();
  return /*#__PURE__*/_jsx(MuiGrid, _objectSpread(_objectSpread({}, props), {}, {
    spacing: useResponsiveSpacing ? getResponsiveGridSpacing(windowWidth, theme) : props.spacing,
    className: classNames(props.className, _defineProperty({}, gridClasses.smMdGrid, useSmMdClass))
  }));
};
export default Grid;